<template>
    <MainContent title="Editar plantilla">
        <template v-slot:header>
            <h3 class="card-title mb-3">Editar plantilla</h3>
        </template>
        <template v-slot:content>
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
                <ContentOrLoading>
                    <b-row v-if="!loading">
                        <b-col cols="6">
                            <FormInput label="Nombre:" type="text" rules="required" name="nombre" v-model="plantilla.nombre" />
                        </b-col>
                        <b-col cols="6">
                            <FormInput label="Descripción:" type="text" rules="required" name="descripcion" v-model="plantilla.description" />
                        </b-col>
                    </b-row>
                </ContentOrLoading>
            </ValidationObserver>
            <ValidationObserver tag="form" ref="contenido" @submit.prevent="submit">
                <ContentOrLoading>
                    <b-row v-if="!loading">
                        <b-col cols="12" class="mt-2">
                            <b-tabs>
                                <b-tab title="Editor de texto" @click="cambiarTab('editor')">
                                    <div class="form-group mt-3" v-if="activeTab === 'editor'">
                                        <label for="contenido">Contenido de la plantilla</label>
                                        <ValidationProvider name="contenido del comunicado" rules="required" mode="lazy" v-slot="{ errors }">
                                            <QuillEditor 
                                                v-model="plantilla.html"
                                            />
                                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">
                                                {{ errors[0] }}
                                            </span>
                                        </ValidationProvider>
                                    </div>
                                </b-tab>
                                <b-tab title="Editor drag and drop" @click="cambiarTab('dragdrop')">
                                    <label for="contenido" class="mt-3">Contenido de la plantilla</label>
                                    <EmailGrapesJs v-model="plantilla.html" v-if="activeTab === 'dragdrop'"/>
                                </b-tab>
                                <b-tab title="Fuente HTML" @click="cambiarTab('html')">
                                    <label for="contenido" class="mt-3">Contenido de la plantilla en HTML</label>
                                    <b-form-textarea
                                        v-model="plantilla.html"
                                        id="contenido"
                                        name="contenido"
                                        :rows="10"
                                        placeholder="Introduce el código HTML"
                                        class="form-control"
                                    />
                                </b-tab>
                                <b-tab title="Previsualizar" @click="cambiarTab('preview')">
                                    <div class="content-preview p-3" v-if="activeTab === 'preview'">
                                        <div v-html="plantilla.html"></div>
                                    </div>
                                </b-tab>
                            </b-tabs>                    
                        </b-col>
                        <b-col cols="12" class="mt-2 text-right">
                            <button id="continuar" class="button" type="submit" :disabled="loading">
                                <span>Continuar</span>
                            </button>
                        </b-col>
                        <b-col cols="6" class="mt-4 text-right ml-auto" v-if="error" >
                            <div class="alert alert-danger d-flex align-items-center justify-content-between m-0" role="alert">
                                <button @click="quitarError" class="button mr-4" >OK</button>
                                <p class="mb-0 ">Utiliza imágenes del gestor de medios para que se muestren correctamente.</p>
                            </div>
                        </b-col>
                    </b-row>
                </ContentOrLoading>
            </ValidationObserver>

        </template>        
    </MainContent>    
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import QuillEditor from "@/views/backend/campana-emails/boletines/QuillEditor.vue";
    import EmailGrapesJs from "@/components/backend/components/EmailGrapesJs.vue";

    export default {
        data() {
            return {
                loading: false,
                plantilla: {},
                error: false,
                activeTab: 'editor'
            }
        },
        methods: {
            cambiarTab(tab) {
                this.activeTab = tab;
                this.$forceUpdate();
            },
            async submit() {
                const isValid = await this.$refs.contenido.validate();

                if (isValid) {
                    this.loading = true;
                    try {
                        await apiService.editarPlantilla(this.$route.params.plantilla_id, this.plantilla);
                        this.$toast.success('Plantilla actualizada correctamente');
                        this.$router.push({ name: 'back.emails.plantilla.index' });
                    } catch (error) {
                        this.$toast.error('Error al editar la plantilla');
                        this.error = true;
                        console.error('Error al editar la plantilla:', error);
                    } finally {
                        this.loading = false;
                    }
                }
            },
            async getPlantilla() {
                this.loading = true;
                try {
                    const response = await apiService.getPlantilla(this.$route.params.plantilla_id);
                    this.plantilla = response.data;
                } catch (error) {
                    console.error('Error al cargar la plantilla:', error);
                    this.$toast.error('Error al cargar la plantilla');
                } finally {
                    this.loading = false;
                }
            },            quitarError() {
                this.error = false;
            }
        },
        mounted() {
            this.getPlantilla();
        },
        watch: {
            'loading': {
                handler() {
                    this.cambiarTab('editor');
                }
            }
        },

        components: {
            MainContent,
            QuillEditor,
            EmailGrapesJs
        }
    }
</script>
